var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchLandlord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8,
    cy: 17.0998,
    r: 16.8,
    fill: "#B84730"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6831 18.6631C23.5448 18.6631 25.8647 16.3432 25.8647 13.4814C25.8647 10.6197 23.5448 8.2998 20.6831 8.2998C17.8213 8.2998 15.5014 10.6197 15.5014 13.4814C15.5014 16.3432 17.8213 18.6631 20.6831 18.6631ZM20.6831 16.0723C22.1139 16.0723 23.2739 14.9123 23.2739 13.4814C23.2739 12.0506 22.1139 10.8906 20.6831 10.8906C19.2522 10.8906 18.0922 12.0506 18.0922 13.4814C18.0922 14.9123 19.2522 16.0723 20.6831 16.0723Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14502 25.1548C8.51266 24.5224 8.51266 23.4971 9.14502 22.8648L16.244 15.7658L18.534 18.0558L11.435 25.1548C10.8026 25.7871 9.77738 25.7871 9.14502 25.1548Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.122 24.4678L15.328 21.2618L16.702 22.6358C16.9549 22.8887 16.9549 23.2988 16.702 23.5518L14.412 25.8418C14.159 26.0947 13.7489 26.0947 13.496 25.8418L12.122 24.4678Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLandlord);
export default __webpack_public_path__ + "static/media/search-landlord.f9caa167.svg";
export { ForwardRef as ReactComponent };